import React from 'react';
import { classNames } from 'helpers';
import { Link, Image, Video } from 'components';
import './styles.scss';

const CardArticle = props => {
  const { url, title, logo, thumbnail, video, category } = props;
  const classes = classNames('card', { 'card-with-video': video?.url });

  return (
    <Link className={classes} to={url}>
      <div className="card-logo">
        <div className="card-logo-container">
          <Image image={logo} />
        </div>
      </div>
      <div className="card-media">
        <div className="card-image">
          <Image image={thumbnail} />
        </div>
        <div className="card-video">
          <Video src={video?.url} playOnOver />
        </div>
      </div>
      <div className="card-content">
        <span className="card-category">{category}</span>
        <span className="card-separator">/</span>
        <span className="card-title">{title?.text}</span>
      </div>
    </Link>
  );
};

export default CardArticle;
